<template>
<div class="test">
<b-container class="h-100">
        <b-row class="align-items-center">
            <b-col cols="12">
                <b-row class="align-items-center">
                    <p class="frontbreadcrumb"> <font-awesome-icon icon="book-open"></font-awesome-icon></p>
                    <b-breadcrumb :items="items"></b-breadcrumb>
                </b-row>
            </b-col>
        </b-row>
        
        <!-- Default -->
        <b-row v-if="!main && !sub" class="justify-content-around align-items-center h-100">
            <b-col cols="12">
                <b-row class="justify-content-around">
                    <b-col v-if="isPlatformDoc" cols="12" sm="12" md="6" lg="4">
                        <div class="panel clikable" @click="$router.push('/doc/platform')"> 
                            <b-img fluid-grow :src="require('@/assets/logo_Q_Platform.svg')">
                                <h2>Platform</h2>
                            </b-img>
                        </div>
                    </b-col>
                    <b-col cols="12" sm="12" md="6" lg="4">
                        <div class="panel clikable" @click="$router.push('/doc/plugin')">
                            <b-img fluid-grow :src="require('@/assets/logo_Q_Plugin.svg')">
                                <h2>Plug-In</h2>
                            </b-img>
                        </div>
                    </b-col>
                </b-row>
                <b-row class="justify-content-around marginaltop">
                    <b-col cols="12" sm="12" md="6" lg="4">
                        <div class="panel clikable" @click="$router.push('/doc/visualizationtool')"> 
                            <b-img fluid-grow :src="require('@/assets/logo_Q_VisualizationTool.svg')">
                                <h2>Visualizing tool</h2>
                            </b-img>
                        </div>
                    </b-col>
                    <b-col cols="12" sm="12" md="6" lg="4">
                        <div class="panel clikable" @click="$router.push('/doc/analytics')"> 
                            <b-img fluid-grow :src="require('@/assets/logo_Q_Analytics.svg')">
                                <h2>Analytics</h2>
                            </b-img>
                        </div>
                    </b-col>  
                </b-row>
            </b-col> 
        </b-row>

        <!-- Visualization Tool -->
        <b-row v-if="main === 'visualizationtool' && !sub" class="justify-content-around align-items-center">
            <VisualizationTool></VisualizationTool>
        </b-row>

        <!-- Visualization Tool -->
        <b-row v-if="main === 'analytics' && !sub" class="justify-content-around align-items-center">
            <AnalyticsDoc></AnalyticsDoc>
        </b-row>

        <!-- Plugin -->
        <b-row v-if="main === 'plugin' && !sub" class="justify-content-around align-items-center h-100">
            <b-col cols="6" sm="6" md="4" lg="4">
                <div class="panel panelsize clikable" @click="$router.push('/doc/plugin/videojs')"> 
                    <b-row class="justify-content-center align-items-center">
                        <b-img class="myimg2" :src="require('@/assets/external_logo/videojs.svg')">
                            <h2>VideoJS</h2>
                        </b-img>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="6" sm="6" md="4" lg="4">
                <div class="panel panelsize clikable" @click="$router.push('/doc/plugin/hlsjs')">
                    <b-row class="justify-content-center align-items-center">
                        <b-img class="myimg" :src="require('@/assets/external_logo/hlsjs.png')">
                            <h2>Hls.js</h2>
                        </b-img>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="6" sm="6" md="4" lg="4">
                <div class="panel panelsize clikable" @click="$router.push('/doc/plugin/dashjs')"> 
                    <b-row class="justify-content-center align-items-center">
                        <b-img class="myimg" :src="require('@/assets/external_logo/dashjs.png')">
                            <h2>Dash.js</h2>
                        </b-img>
                    </b-row>
                </div>
            </b-col>
            <!--<b-col cols="6" sm="6" md="4" lg="4">
                <div class="panel panelsize clikable" @click="$router.push('/doc/plugin/shakaplayer')"> 
                    <b-row class="justify-content-center align-items-center">
                        <b-img class="myimg" :src="require('@/assets/external_logo/shakaplayer.png')">
                            <h2>Shaka Player</h2>
                        </b-img>
                    </b-row>
                </div>
            </b-col>-->
            
            <b-col cols="6" sm="6" md="4" lg="4">
                <div class="panel panelsize clikable" @click="$router.push('/doc/plugin/brightcove')"> 
                    <b-row class="justify-content-center align-items-center">
                        <b-img class="myimg" :src="require('@/assets/external_logo/brightcove.png')">
                            <h2>Brightcove</h2>
                        </b-img>
                    </b-row>
                </div>
            </b-col>
            <b-col cols="6" sm="6" md="4" lg="4">
                <div class="panel panelsize clikable" @click="$router.push('/doc/plugin/flowplayer')"> 
                    <b-row class="justify-content-center align-items-center">
                        <b-img class="myimg" :src="require('@/assets/external_logo/flowplayer.png')">
                            <h2>Flowplayer</h2>
                        </b-img>
                    </b-row>
                </div>
            </b-col>
        </b-row>

        <!-- Plugin/DASH -->
        <b-row v-if="main === 'plugin' && sub === 'dashjs'" class="justify-content-around align-items-center">
           <Dashjs></Dashjs>
        </b-row>

        <b-row v-if="main === 'plugin' && sub === 'hlsjs'" class="justify-content-around align-items-center">
            <Hlsjs></Hlsjs>
        </b-row>

        <b-row v-if="main === 'plugin' && sub === 'shakaplayer'" class="justify-content-around align-items-center">
            <ShakaPlayer></ShakaPlayer>
        </b-row>

        <b-row v-if="main === 'plugin' && sub === 'videojs'" class="justify-content-around align-items-center">
            <b-col cols="12">
                <Videojs></Videojs>
            </b-col>
        </b-row>

        <b-row v-if="main === 'plugin' && sub === 'videojsvhs'" class="justify-content-around align-items-center">
            <b-col cols="12">
                <VideojsVHS></VideojsVHS>
            </b-col>
        </b-row>

        <b-row v-if="main === 'plugin' && sub === 'brightcove'" class="justify-content-around align-items-center">
            <Brightcove></Brightcove>
        </b-row>

        <b-row v-if="main === 'plugin' && sub === 'flowplayer'" class="justify-content-around align-items-center">
            <Flowplayer></Flowplayer>
        </b-row>
</b-container>
</div>
</template>
<script>
import VisualizationTool from '@/components/documentation/plugins/VisualizationTool.vue';
import AnalyticsDoc from '@/components/documentation/plugins/AnalyticsDoc.vue';

import Dashjs from '@/components/documentation/plugins/Dashjs.vue';
import Hlsjs from '@/components/documentation/plugins/Hlsjs.vue';
import ShakaPlayer from '@/components/documentation/plugins/ShakaPlayer.vue';
import Videojs from '@/components/documentation/plugins/Videojs.vue';
import VideojsVHS from '@/components/documentation/plugins/VideojsVHS.vue';
import Brightcove from '@/components/documentation/plugins/Brightcove.vue';
import Flowplayer from '@/components/documentation/plugins/Flowplayer.vue';

export default {
  name: 'Doc',
  data: function() {
    return {
      main: undefined,
      sub: undefined,
      isPlatformDoc: false,
      items: [
          {
            text: 'Documentation',
            href: '#/doc'
          },
      ]
    }
  },
  components: {
      VisualizationTool,
      AnalyticsDoc,
      Dashjs,
      Hlsjs,
      ShakaPlayer,
      Videojs,
      VideojsVHS,
      Brightcove,
      Flowplayer
  },
  watch: {
      '$route' (to, from) {
            this.updateRoute();
      }
  },
  mounted: function() {
    this.updateRoute();
    this.$nextTick(() => {
        Prism.highlightAll()
      });  
  },
  methods: {
      updateRoute() {
        this.main = undefined;
        this.sub = undefined;
        this.items = [
            {
                text: 'Documentation',
                href: '#/doc'
            },
        ]
        try {
            this.main = this.$route.params["main"];
        } catch(err) {

        }
        try {
            this.sub = this.$route.params["sub"];
        } catch(err) {

        }
        if (this.main) {
            let href = `#/doc/${this.main}`;
            let item = {href: href};
            switch(this.main) {
                case 'platform':
                    item.text = 'Platform'
                    break;
                case 'plugin':
                    item.text = 'Plug-In'
                    break;
                case 'visualizationtool':
                    item.text = 'Visualization Tool'
                    break;
                case 'analytics':
                    item.text = 'Analytics'
                    break;
                default:
                    item.text = this.main;
                    break;
            }
            this.items.push(item);
        }

        if (this.sub) {
            let href = `#/doc/${this.main}/${this.sub}`;
            let item = {href: href};
            switch(this.sub) {
                case 'hlsjs':
                    item.text = 'HLS.js'
                    break;
                case 'dashjs':
                    item.text = 'dash.js'
                    break;
                case 'videojs':
                    item.text = 'VideoJS'
                    break;
                case 'shakaplayer':
                    item.text = 'Shaka Player'
                    break;
                case 'brightcove':
                    item.text = 'Brightcove'
                    break;
                case 'flowplayer':
                    item.text = 'Flowplayer'
                    break;
                default:
                    item.text = this.sub;
                    break;
            }
            this.items.push(item);
            
        }
        this.items = this.items.splice(0);
        console.log(this.$route.name);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.panel {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    background-color: #FBFCFC;
    border: solid 1px;
    border-color: #2a5d77;
    border-radius: 15px;
    height: 100%;
    text-align: center;
    padding: 40px 30px;
    box-shadow: 0px 6px 30px -2px rgba(0, 0, 0, 0.2);
    transition: .15s all ease-in-out;
    &:hover {
        transform: translateY(-1px);
        box-shadow: 0px 15px 40px -20px rgba(0, 0, 0, 0.2);
    }
}

.myimg {
    max-width: 100%;
    width: auto;
    height: auto;
    max-height: 100%
}

.myimg2 {
    
}
@media (min-width: 992px) {
    .myimg2 {
        min-width: 170%;
    }
}
@media (min-width: 1200px) {
    .myimg2 {
        min-width: 200%;
    }
}


.panelsize {
    min-height: 150px;
    max-height: 150px;
    height: 150px;
}

.test {
    height: calc(50vh - 49px);
}

.breadcrumb {
    background-color: #ffffff;
}

.breadcrumb-item.active {
    color: #14BF98;
    font-weight: 500;
}
.breadcrumb-item > a{
    color: #2F90B0;
    font-weight: 500;
}

.frontbreadcrumb {
    color: #2F90B0;
    font-weight: 500;
    padding-left: 1rem;
}
</style>